import { useMemo } from "react";

import type { RouterOutputs } from "~/utils/api";

type BySphereReturnType =
  RouterOutputs["scores"]["bySphere"]["recommendations"];

export const useConstructRecommendations = (data?: BySphereReturnType) => {
  const result = useMemo(() => {
    const recommendations = data?.map((req, index) => ({
      id: `rec-${index}`,
      text: req.title,
      tag: req.type,
      image: req.image,
      tagColor: req.color,
      doctorProposal: req.doctorProposal,
      dialog: {
        tag: req.type,
        tagColor: req.color,
        title: req.title,
        markdown: req.content,
        accordion: req.terminologyExplanation?.map((terms, idx) => ({
          id: `term-${idx}`,
          title: terms.title,
          content: terms.explanation,
        })),
      },
    }));
    return recommendations;
  }, [data]);
  return result;
};
